export enum HolidayTypeEnum {
  NATIONAL = "NATIONAL",
  REGIONAL = "REGIONAL",
  LOCAL = "LOCAL",
  COMPANY_HOLIDAY = "COMPANY_HOLIDAY",
  AGREEMENT_REST = "AGREEMENT_REST",
}

export const getHolidayTypeLabel = (type: HolidayTypeEnum): string => {
  switch (type) {
    case HolidayTypeEnum.NATIONAL:
      return "Nacional";
    case HolidayTypeEnum.REGIONAL:
      return "Autonómico";
    case HolidayTypeEnum.LOCAL:
      return "Local";
    case HolidayTypeEnum.COMPANY_HOLIDAY:
      return "Festivo de empresa";
    case HolidayTypeEnum.AGREEMENT_REST:
      return "Descanso convenio";
    default:
      return String(type);
  }
};

export const getHolidayTypeOptions = (includeOnly?: string[]): { label: string; value: string }[] => {
  const keys = Object.keys(HolidayTypeEnum).filter(
    (key: string) =>
      typeof HolidayTypeEnum[key as keyof typeof HolidayTypeEnum] === "string" &&
      (!includeOnly || includeOnly.includes(key))
  );
  return keys.map((val) => {
    const value = HolidayTypeEnum[val as keyof typeof HolidayTypeEnum];
    return { label: getHolidayTypeLabel(value), value: value };
  });
};
